export const magdaBazan = {
    'mydrId': 'magdabazan',
    'firstName': 'Magda',
    'lastName': 'Bazan',
    'profession': 'Lekarz rezydent psychiatrii',
    'avatar': 'magda-bazan.webp',
    'slug': 'psychiatra-magda-bazan',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'adult']
    ]
}